import type { IDocumentVersion } from '@apis/documents';

/**
 * The version blocking any newer one from being decided — the lowest in review,
 * since decisions run oldest-first. Null means an upload may approve itself.
 *
 * Mirrors the server's rule so the UI can say why up front, but it reads a
 * listing that can be stale: the upload's own `approved` result stays the gate.
 */
export function versionAwaitingDecision(versions: IDocumentVersion[]): number | null {
  const pending = versions.filter((v) => v.status === 'in_review').map((v) => v.version);
  return pending.length > 0 ? Math.min(...pending) : null;
}
